package ru.villawonka.app.presentation.screens.variantPicker.model

data class VariantPickerItemUIModel(
    val title: String,
    val subtitle: String? = null
)